import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface ShowMetadataProps {
  defaultEnabled: boolean | null;
}

const ShowMetadata: FunctionComponent<ShowMetadataProps> = ({ defaultEnabled }) => (
  <I18nProviderWrapper>
    <SettingsEnableDisable
      defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
      description={bfTranslate('Only applies to assets in Collections and Share Links')}
      errorTitle={bfTranslate('Error updating metadata viewing permissions. Please contact support.')}
      id="show-metadata"
      successTitle={bfTranslate('Metadata viewing permissions updated!')}
      title={bfTranslate('Allow guest and public users to see metadata')}
      updateResourceKey="showMetadata"
    />
  </I18nProviderWrapper>
);

export default ShowMetadata;
